import { useQuery } from '@apollo/react-hooks';
import { getURLParameter } from '../../../../helpers';
import {
  QUERY_LENDER_PROFILE_BY_DYNAMICS_ID,
  QUERY_CREDIT_SUBMISSION_PUBLIC,
  QUERY_VENDOR_OPPORTUNITY,
  Q_CREDIT_APP_PUBLIC,
} from '../../../../api';

import { Task } from '@trnsact/trnsact-shared-types';
import { QUERY_FINANCE_PROGRAM_PUBLIC } from '../api/financeProgramQueries';
import {
  CreditApplicationResponse,
  CreditSubmissionResponse,
  FinanceProgramResponse,
  LenderProfileResponse,
  VendorOpportunityResponse
} from '../types';

export const useInsuranceVerificationDataFetch = (task: Task) => {

  const lenderProfileDynamicsId = getURLParameter('lenderProfileDynamicsId');

  const {
    data: lenderProfileData,
    loading: isLenderProfileLoading
  } = useQuery<LenderProfileResponse>(QUERY_LENDER_PROFILE_BY_DYNAMICS_ID, {
    variables: { lenderProfileDynamicsId },
  });

  const {
    data: creditSubmissionData,
    loading: isCreditSubmissionLoading
  } = useQuery<CreditSubmissionResponse>(QUERY_CREDIT_SUBMISSION_PUBLIC, {
    variables: { dynamicsId: task.creditSubId },
  });

  const {
    data: vendorOpportunityData,
    loading: isVendorOpportunitLoading
  } = useQuery<VendorOpportunityResponse>(QUERY_VENDOR_OPPORTUNITY, {
    variables: { voId: task.vendorOpportunityId },
  });

  const {
    data: creditApplicationData,
    loading: isCreditApplicationLoading
  } = useQuery<CreditApplicationResponse>(Q_CREDIT_APP_PUBLIC, {
    variables: { id: task.creditApplicationId },
  });

  const {
    data: financeProgramData,
    loading: isFinanceProgramLoading
  } = useQuery<FinanceProgramResponse>(QUERY_FINANCE_PROGRAM_PUBLIC, {
    variables: { financeProgramId: task.financeProgramId },
  });

  const isLoading = isLenderProfileLoading ||
    isCreditSubmissionLoading ||
    isVendorOpportunitLoading ||
    isCreditApplicationLoading ||
    isFinanceProgramLoading;

  return {
    lenderProfile: lenderProfileData?.getLenderProfileByDynamicsId,
    creditSubmission: creditSubmissionData?.creditSubmissionPublic,
    vendorOpportunity: vendorOpportunityData?.vendorOpportunityPublic,
    creditApplication: creditApplicationData?.creditApplicationPublic,
    financeProgram: financeProgramData?.financeProgramPublic,
    isLoading,
  };
};
